var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 235.519H513V342.688H0V235.519Z",
    fill: "#009543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 106.467H513V235.759H0V106.467Z",
    fill: "#ED4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.661133H513V107.509H0V0.661133Z",
    fill: "#0035AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.375 297.72C262.01 297.72 318.461 241.27 318.461 171.635C318.461 101.999 262.01 45.5488 192.375 45.5488C122.74 45.5488 66.2891 101.999 66.2891 171.635C66.2891 241.27 122.74 297.72 192.375 297.72Z",
    fill: "#FAE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.375 48.1984C124.203 48.1984 68.9392 103.463 68.9392 171.634C68.9392 239.806 124.203 295.07 192.375 295.07C260.547 295.07 315.811 239.806 315.811 171.634C315.811 103.463 260.547 48.1984 192.375 48.1984ZM63.6392 171.634C63.6392 100.535 121.276 42.8984 192.375 42.8984C263.474 42.8984 321.111 100.535 321.111 171.634C321.111 242.733 263.474 300.37 192.375 300.37C121.276 300.37 63.6392 242.733 63.6392 171.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.801 284.815L221.311 294.434L192.375 297.801L162.076 295.877L133.3 283.453C133.3 283.453 156.224 259.967 165.923 256.6C172.817 254.196 183.878 253.634 183.878 253.634V98.452L183.638 45.5488H197.184L196.784 99.6543V253.314C196.784 253.314 209.047 254.276 214.498 256.6C223.556 260.528 246.801 284.815 246.801 284.815Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.514 82.7211L204.945 65.5532L209.416 74.5203L174.984 91.6874L170.514 82.7211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.612 246.741C198.049 246.741 204.078 237.231 204.078 225.499C204.078 213.768 198.049 204.258 190.612 204.258C183.175 204.258 177.146 213.768 177.146 225.499C177.146 237.231 183.175 246.741 190.612 246.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.291 132.358C199.543 132.358 207.043 124.857 207.043 115.605C207.043 106.353 199.543 98.8525 190.291 98.8525C181.038 98.8525 173.538 106.353 173.538 115.605C173.538 124.857 181.038 132.358 190.291 132.358Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.093 179.57C199.902 179.57 207.044 175.227 207.044 169.871C207.044 164.514 199.902 160.172 191.093 160.172C182.283 160.172 175.142 164.514 175.142 169.871C175.142 175.227 182.283 179.57 191.093 179.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.374 142.538H209.047V150.553H171.374V142.538ZM171.374 188.227H209.047V196.242H171.374V188.227Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342.027,
    fill: "white",
    transform: "translate(0 0.661133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/NC.c19d1ce91e4ddc5306fc630453467b19.svg";
export { ForwardRef as ReactComponent };